module.exports = __webpack_public_path__ + "img/population.16f08b89.png";